export const MIME_TYPE_EXTENSION_MAP: Record<string, string> = {
  'audio/webm': 'webm',
  'audio/webm;codecs=opus': 'webm',
  'audio/ogg': 'ogg',
  'audio/ogg;codecs=opus': 'ogg',
  'audio/mp4': 'm4a',
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
  'audio/x-wav': 'wav',
}

export function getExtensionFromMimeType(mimeType: string | undefined): string {
  const normalized = mimeType?.toLowerCase()
  if (!normalized) return 'webm'

  const directMatch = MIME_TYPE_EXTENSION_MAP[normalized]
  if (directMatch) {
    return directMatch
  }

  const withoutCodec = normalized.split(';')[0]
  return MIME_TYPE_EXTENSION_MAP[withoutCodec] ?? 'webm'
}

export function isVoiceInputSupported(): boolean {
  return typeof navigator !== 'undefined' &&
    Boolean(navigator.mediaDevices?.getUserMedia) &&
    typeof MediaRecorder !== 'undefined'
}
